'use client';

import { c as _c } from "react/compiler-runtime";
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../constants';
import { useCacheKey } from './useCacheKey';
import { useDecisions } from './useDecisions';
type DeviceType = 'mobile' | 'tablet' | 'desktop';
type DeviceTypeResult = {
  deviceType: DeviceType;
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
};

/**
 * @deprecated Prefer CSS media queries for responsive UI. Use this hook only
 * for JavaScript behavior that CSS cannot express. The server uses the
 * User-Agent-based `x-petm-device` header, while the client uses media queries,
 * so the value may change after hydration and cause a layout shift.
 */
export const useDeviceType = () => {
  const $ = _c(7);
  const {
    headers
  } = useCacheKey();
  const {
    breakpoint
  } = useDecisions();
  let t0;
  if ($[0] !== headers) {
    t0 = headers.get("x-petm-device");
    $[0] = headers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const deviceTypeFromHeader = t0;
  const isTabletFromHeader = deviceTypeFromHeader === "tablet";
  const isDesktopFromHeader = deviceTypeFromHeader === "desktop";
  const isTablet = useMedia(`(min-width: ${BREAKPOINTS.sm2}px)`, isTabletFromHeader);
  const isDesktop = useMedia(`(min-width: ${BREAKPOINTS.lg}px)`, isDesktopFromHeader);
  const isTablet2 = useMedia(`(min-width: ${BREAKPOINTS.md}px)`, isTabletFromHeader);
  const isDesktop2 = useMedia(`(min-width: ${BREAKPOINTS.lg}px) and (hover: hover) and (pointer: fine)`, isDesktopFromHeader);
  const selectedDesktop = breakpoint ? isDesktop2 : isDesktop;
  const matchesTablet = breakpoint ? isTablet2 : isTablet;
  const t1 = !selectedDesktop && matchesTablet;
  const t2 = !matchesTablet && !selectedDesktop;
  const t3 = selectedDesktop ? "desktop" : matchesTablet ? "tablet" : "mobile";
  let t4;
  if ($[2] !== selectedDesktop || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      isDesktop: selectedDesktop,
      isTablet: t1,
      isMobile: t2,
      deviceType: t3
    };
    $[2] = selectedDesktop;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};